import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApolloError } from 'apollo-boost';
import cn from 'classnames';
import { Notes } from '../../../types';
import { useTheme } from '../../../../theme';
import Link from '../../../../Link';
import { CdnIcon } from '@shared/ui';
import { InfoMessagePositionsEnum } from '@websky/graphql';
import InfoMessages from '../../../../InfoMessages';

interface Props {
	isLoading: boolean;
	error: ApolloError;
	notes: Notes;
	isFullFareConditions: boolean;
	onLinkClick: React.MouseEventHandler<HTMLLinkElement>;
}

const Footer: React.FC<Props> = ({ isLoading, error, notes, isFullFareConditions, onLinkClick }) => {
	const { t } = useTranslation('CompareFares');
	const { Footer: css } = useTheme('CompareFares');

	if (isLoading && error) {
		return null;
	}

	return (
		<>
			{isFullFareConditions && notes && (
				<div>
					<h6 className={css.notesHeading}>{t(notes.heading)}</h6>
					<ul className={css.notesList}>
						{notes.notesList.map((note, index) => (
							<li key={index} className={css.notesListItem}>
								{index + 1}. {t(note)}
							</li>
						))}
					</ul>
				</div>
			)}

			<InfoMessages
				position={InfoMessagePositionsEnum.compareTable}
				className={css.infoMessage}
				itemClassName={css.infoMessage__item}
				htmlClassName={css.infoMessage__html}
			/>

			<Link action={onLinkClick} className={css.link}>
				<span className={css.link__wrapper}>
					<span className={css.linkTitle}>
						{isFullFareConditions ? t('Go back') : t('View full fare conditions')}
					</span>
					<span className={cn(css.linkIcon, { [css.linkIcon_return]: isFullFareConditions })}>
						{<CdnIcon icon="Arrow/Chevron_right" />}
					</span>
				</span>
			</Link>
		</>
	);
};

export default Footer;
